/**
 * Checks if a value is a non-empty string
 *
 * ```ts
 * isNonEmptyString('hello') // true
 * isNonEmptyString('') // false
 * isNonEmptyString(null) // false
 * isNonEmptyString(undefined) // false
 * isNonEmptyString('   ') // false
 * ```
 *
 * @param value - The value to check
 * @returns
 */
export const isNonEmptyString = (value: string | null | undefined): boolean =>
  value != null && value.trim() !== '';
